module.exports = __webpack_public_path__ + "static/img/home5.d2b32e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/home5.jpg
// module id = N3VY
// module chunks = 0